export default __webpack_public_path__ + "static/media/blank-email.43ebbcaa.jpg";